import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe, QueryRepoCommitArgs, RepoCommit } from "types/generated";
import { PickInner } from "types/helpers";

export type SpaceliftVcsRepoCommitDetails = Pick<
  RepoCommit,
  "id" | "sha" | "message" | "description" | "authorName" | "authorEmail" | "createdAt"
> & {
  files: PickInner<RepoCommit["files"], "filePath" | "isDeleted">;
};

export type SpaceliftVcsRepoCommitFile = SpaceliftVcsRepoCommitDetails["files"][number];

export const GET_SPACELIFT_VCS_REPO_COMMIT: TypedDocumentNode<
  { repoCommit: Maybe<SpaceliftVcsRepoCommitDetails> },
  QueryRepoCommitArgs
> = gql`
  query GetSpaceliftVcsRepoCommit($repoID: ID!, $sha: String) {
    repoCommit(repoID: $repoID, sha: $sha) {
      id
      sha
      message
      description
      authorName
      authorEmail
      createdAt
      files {
        filePath
        isDeleted
      }
    }
  }
`;
